import { Injectable } from '@angular/core';
import { QuerystringService } from './querystring';
import { RuntimeFrameworkService } from './rtf-service';
import { of, Observable, BehaviorSubject, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
// tslint:disable: no-string-literal
/**
 * åæ°æå¡
 * @scope FormModule
 */
@Injectable()
export class ParamService {
  constructor(
    private querystringService: QuerystringService,
    private runtimeFrameworkService: RuntimeFrameworkService
  ) { }
  /**
   * ééè·åææåæ°
   */
  public get params(): Observable<{ [propName: string]: any }> {
    // åä»hashä¸­è·ååæ°
    const hash = window.location.hash;
    const params = this.querystringService.parse(hash);
    /*
    const appMode = params.appMode;
    // appModeæ²¡æå®ä¹ï¼è®¤ä¸ºæ¯èè¡¨å,appMode = mdi æ spa
    if (typeof appMode === 'undefined' || appMode === null) {
        return of(params);
    }
    // appModeå­å¨ï¼ä½ä¸ºç©ºï¼ä¹è®¤ä¸ºæ¯èè¡¨å
    if (appMode.length < 1) {
        return of(params);
    }
    // æ°è¡¨åï¼ä½¿ç¨iframeæ¨¡å¼
    if (appMode.toLowerCase() === 'mdi') {
        return of(params);
    }
    */
    // è·åtabIdï¼ææ°çæ¬ä¸å®ætabIdï¼å¦æåä¸å°tabIdåè®¤ä¸ºæ¯èè¡¨åï¼ç´æ¥ä»urlè·ååæ°
    const tabId = params.tabId;
    if (!tabId) {
      // throw new Error('TabId can`t be empty!');
      return of(params);
    }
    const subject = new Subject<any>();
    // ç®¡éåæ°eå¯è½ä¸ºobjectãMapç±»å
    this.runtimeFrameworkService.addEventListener(tabId, (e: any) => {
      let map = {};
      if (e instanceof Map || (e && typeof (e['get']) === 'function' && typeof e['entries'] === 'function')) {
        map = this.parseMapParams(e);
      }
      let args = {};
      if (e instanceof Map || (e && typeof (e['get']) === 'function' && typeof e['entries'] === 'function')) {
        args = new Map(e);
      } else {
        args = Object.assign({}, e);
      }
      setTimeout(() => {
        subject.next(Object.assign({}, args, map, params));
      }, 0);
    }, params);
    return subject.asObservable();
  }
  /**
   * è§£æmapç±»åçåæ°
   * @param params params
   */
  private parseMapParams(params: Map<any, any>) {
    const map = {};
    map['WEB_FORM_ROUTE_PARAMS'] = decodeURIComponent(params.get('WEB_FORM_ROUTE_PARAMS'));
    params.forEach((value, key) => {
      if (key !== 'WEB_FORM_ROUTE_PARAMS') {
        map[key] = value;
      }
    });
    return map;
  }
  /**
   * è·åparamåæ°
   * @param param key
   */
  public get(param: string): Observable<any> {
    return this.params.pipe(
      switchMap(options => {
        if (!!options && options.hasOwnProperty(param)) {
          return of(options.param);
        } else {
          return of(undefined);
        }
      })
    );
  }
  /**
   * åæ°è½¬ä¸ºå¯¹è±¡
   */
  public parse(): Observable<any> {
    return this.params.pipe(
      switchMap(options => {
        return of(options);
      })
    );
  }
}
